type TimeRangeSetting = {
    from?: number
    to?: number
};
function isWithinTimeRange({ from, to }: TimeRangeSetting): boolean {
	const currentTime = new Date().getTime();
	const isAlreadyBegin = !from || from <= currentTime;
	const isStillInTheRange = !to || currentTime <= to;
	return isAlreadyBegin && isStillInTheRange;
}
const DEFAULT_TIME_CONSTRAINT = 1732982399000 // 2024/11/30 23:59:59 GMT+8
type TimeSensitiveNewTagProps = {
    className?: string,
    text?: string,
	timeRange?: TimeRangeSetting
};
export const TimeSensitiveNewTag = ({
	className = 'new-tag',
	text = 'NEW',
	timeRange = { to: DEFAULT_TIME_CONSTRAINT }
}: TimeSensitiveNewTagProps) => {
	const isVisible = isWithinTimeRange(timeRange);
	return !isVisible ? null : (
		<div className={className}>{text}</div>
	);
};